import React from "react";
import { useSelector } from "react-redux";

import { ILoaderProps } from "@/types/commonComponents.types";
import { IInitialState } from "@/types/initialState.types";
import styles from "./Loader.module.css";

function Loader({ isFullScreen }: ILoaderProps) {
  const message = useSelector(
    (state: IInitialState) => state.progress?.apiProgressStatus?.message,
  );
  return (
    <div
      className={`${styles.loaderWrapper} ${
        isFullScreen ? styles.fullScreen : ""
      }`}
    >
      <div className={styles.beatLoader}>
        <div />
        <div />
        <div />
      </div>
      {message && <div className={styles.messageContainer}>{message}</div>}
    </div>
  );
}

export default Loader;
